export default __webpack_public_path__ + "static/media/download_gpt.8612aa81.svg";